import SkuInfoList from './skuInfoList';
// 常量
import type { SkuInfoListProps } from './interface';

export type { SkuInfoListProps, };

export default SkuInfoList;
